import { createSlice } from '@reduxjs/toolkit';

export const headerSlice = createSlice({
	name: 'header',
	initialState: {
		pageTitle: 'Home', // current page title state management
		notifications: [], // no of unread notifications
		activities: [], // no of unread activities (athletes feed)
		newNotificationTitle: '', // message title used for push notifications
		newNotificationMessage: '', // message of notification to be shown
		newNotificationStatus: 1, // to check the notification type -  success/ error/ info
		organization: null,
		settings: {},
		user: {},
		pitchesForCompletedWorkout: [],
		nextilesDataForCompletedWorkout: [],
		congratsModal: false,
		isLoading: true,
	},
	reducers: {
		setLoading(state, action) {
			state.isLoading = action.payload;
		},
		setPageTitle: (state, action) => {
			state.pageTitle = action.payload.title;
		},
		setSettings: (state, action) => {
			state.settings = action.payload.settings;
		},
		setOrganization: (state, action) => {
			state.organization = action.payload.organization;
		},
		setUser: (state, action) => {
			state.user = action.payload.user;
		},
		removeNotificationMessage: (state, action) => {
			state.newNotificationMessage = '';
			state.newNotificationTitle = '';
		},
		showNotification: (state, action) => {
			state.newNotificationMessage = action.payload.message;
			state.newNotificationStatus = action.payload.status;
			if (action.payload.title)
				state.newNotificationTitle = action.payload.title;
		},
		setPitchesForCompletedWorkout: (state, action) => {
			state.pitchesForCompletedWorkout = action.payload.pitches;
		},
		setNextilesDataForCompletedWorkout: (state, action) => {
			state.nextilesDataForCompletedWorkout = action.payload.nextilesData;
		},
		setNotifications: (state, action) => {
			state.notifications = action.payload.notifications;
		},
		setActivities: (state, action) => {
			state.activities = action.payload.activities;
		},
		setCongratsModal: (state, action) => {
			state.congratsModal = action.payload.congratsModal;
		},
		setError(state, action) {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const {
	setPageTitle,
	removeNotificationMessage,
	showNotification,
	setSettings,
	setUser,
	setUserRole,
	setPitchesForCompletedWorkout,
	notifications,
	setNotifications,
	setNextilesDataForCompletedWorkout,
	setCongratsModal,
	setActivities,
	setLoading,
	setError,
	setOrganization,
} = headerSlice.actions;

export default headerSlice.reducer;
